import { createActor, canisterId } from "./declarations/backend"
import { queryReady } from "./query_ready.js"
import { overlayRotationSteps } from "./overlay_rotation.js"

// { once: true }: DOMContentLoaded only ever fires once per document.
document.addEventListener("DOMContentLoaded", () => {
  const el = document.getElementById("visits")
  if (!el) return

  const overlayEls = document.querySelectorAll("[data-overlay-image]")

  if (!canisterId) {
    el.textContent = "😵"
    return
  }

  const render = (count) => {
    el.textContent = `${count}`
    const degrees = overlayRotationSteps(count, overlayEls.length)
    overlayEls.forEach((overlayEl, i) => {
      overlayEl.style.setProperty("--overlay-rotation", `${degrees[i]}deg`)
    })
  }

  const backend = createActor(canisterId)

  // visit() is an update call, so it takes a couple of seconds to reach
  // consensus. count() is a query and answers quickly: show it plus the visit
  // we are about to record, and let visit()'s real answer replace it.
  let known = null
  const optimistic = queryReady(backend).then((actor) => actor.count())
    .then((count) => {
      known = count
      render(count + 1n)
    })
    .catch((err) => console.warn("count() failed", err))

  // Settle the query first so a slow count() can never overwrite visit()'s
  // outcome.
  backend.visit()
    .then(
      (count) => optimistic.then(() => render(count)),
      (err) => optimistic.then(() => {
        console.error("visit() failed", err)
        // The visit was not recorded: show what the backend last told us, or
        // say we could not reach it.
        if (known === null) {
          el.textContent = "Visits: unavailable"
        } else {
          render(known)
        }
      })
    )
}, { once: true })
